declare const process: { env: { NODE_ENV: string } };

interface ExtendedWindow extends Window {
  Cypress?: any;
  IS_MAIN_ARDOQ_APP?: boolean;
}

export const isDevelopmentMode = () => {
  return import.meta.env.DEV;
};

export const isAutomatedTestMode = (currentWindow: ExtendedWindow) => {
  return (
    process.env.NODE_ENV === 'test' ||
    import.meta.env.MODE === 'test' ||
    currentWindow.Cypress
  );
};

export const isRunningInArdoqFront = (currentWindow: ExtendedWindow) => {
  return Boolean(currentWindow.IS_MAIN_ARDOQ_APP);
};
